module.exports = __webpack_public_path__ + "static/media/mobile.d3b1269c.png";